// useContactFormData.js

import { useState, useEffect } from 'react';
import { defaultFormData } from '../config/contactFormDataConfig';

const useContactFormData = (initialContact = null) => {
  const [formData, setFormData] = useState(defaultFormData);
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    if (initialContact) {
      setFormData({
        ...defaultFormData,
        ...initialContact,
      });
    } else {
      setFormData(defaultFormData);
    }
    // Reset validation errors when initialContact changes
    setValidationErrors({});
  }, [initialContact]);

  const validateField = (name, value) => {
    let error = '';
    if (['contactName', 'phone1', 'emailAddress'].includes(name)) {
      if (!value || value.trim() === '') {
        error = `${
          name === 'contactName'
            ? 'Name'
            : name === 'phone1'
            ? 'Primary Phone Number'
            : 'Email Address'
        } is required`;
      }
    }
    if (['phone1', 'phone2', 'cellPhone', 'cellPhone2', 'faxNumber'].includes(name) && value) {
      // Ensure the phone number contains only digits
      const phoneRegex = /^\d+$/;
      if (!phoneRegex.test(value)) {
        error = 'Phone number should only contain digits';
      }
    }
    if (['emailAddress', 'emailAddress2'].includes(name) && value) {
      // Simple email format validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        error = 'Invalid email format';
      }
    }
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Update form data
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'contactLevel' ? parseInt(value, 10) : value,
    }));
    // Validate the field
    validateField(name, value);
  };

  const resetForm = () => {
    setFormData(defaultFormData);
    setValidationErrors({});
  };

  return {
    formData,
    setFormData,
    handleChange,
    validationErrors,
    resetForm,
  };
};

export default useContactFormData;
